@if(title) { <h2 mat-dialog-title>{{title}}</h2>}
<mat-dialog-content>
    <ng-template cdkPortalOutlet [cdkPortalOutlet]="content"></ng-template>
</mat-dialog-content>
<mat-dialog-actions>
    @for(button of buttons; track $index) {
        @let isDisabled = resolve(button.disabled);
        <button [matButton]="button.style" class="button-glass" (click)="button.command()" [disabled]="isDisabled">
            {{button.label}}
        </button>
    }
</mat-dialog-actions>
